const viewAny = (permissions) => {
  return permissions.includes('read-resource-categories')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-resource-categories')
}

const update = (permissions) => {
  return hasPermission(permissions, 'update-resource-categories')
}

const deletee = (permissions) => {
  return hasPermission(permissions, 'delete-resource-categories')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};